import React from "react";
import { Icon } from "@qgiv/core-react";
import "./FauxProfile.scss";

const FauxProfile = () => (
    <div className="faux-profile">
        <div className="faux-profile__header" />
        <div className="faux-profile__body">
            <div className="faux-profile__dashboard">
                <div className="faux-profile__dashboard-sidebar">
                    <Icon
                        className="faux-profile"
                        glyph="faux-profile"
                        type="Custom"
                    />
                </div>
                <div className="faux-profile__dashboard-main-content">
                    <h1>My Fundraising Profile</h1>
                    <div className="faux-profile__dashboard-content-block" />
                </div>
            </div>
        </div>
    </div>
);

export default FauxProfile;
